import Component from "vue-class-component";
import Vue from "vue";

@Component
export default class SnackbarMessageHandler extends Vue {
  showErrorSnackbar(text: string): void {
    this.$store.dispatch("snackbars/setErrorSnackbar", text).then(r => r);
  }
  showSuccessSnackbar(text: string): void {
    this.$store.dispatch("snackbars/setConfirmationSnackbar", text).then(r => r);
  }
}
